import type { App } from 'vue';
import { can, hasRole } from '@/services/acl';

export default {
  install(app: App) {
    app.config.globalProperties.$can = can;
    app.config.globalProperties.$hasRole = hasRole;
  }
}
